import { knowledgeApiSlice } from "api/knowledgeApi.slice";
import { UIActionButton } from "common/components";
import { useSelector } from "common/utilities/react-redux";
import { createCanEditTopicSelector } from "entities/topics/selectors";

type KnowledgeItemPinButtonProps = {
  topicId: string;
  knowledgeId: string;
  hideButtonLabels?: boolean;
  isPinned: boolean | null;
};

export const KnowledgeItemPinButton = ({
  topicId,
  knowledgeId,
  hideButtonLabels,
  isPinned,
}: KnowledgeItemPinButtonProps) => {
  const canEditTopic = useSelector(createCanEditTopicSelector(topicId));

  const [pinKnowledge, { isLoading: isPinningKnowledge }] =
    knowledgeApiSlice.endpoints.pinKnowledgeToTopic.useMutation();
  const [unpinKnowledge, { isLoading: isUnpinningKnowledge }] =
    knowledgeApiSlice.endpoints.unpinKnowledgeFromTopic.useMutation();

  const isLoading = isPinningKnowledge || isUnpinningKnowledge;

  const updatePinState = async (event: React.MouseEvent) => {
    event.stopPropagation();

    if (!isPinned) {
      await pinKnowledge({
        topicId,
        knowledgeId,
      });
    } else {
      await unpinKnowledge({
        topicId,
        knowledgeId,
      });
    }
  };

  if (isPinned === null || isPinned === undefined) return null;

  if (!canEditTopic) return null;

  return (
    <UIActionButton
      type={isPinned ? "unpin" : "pin"}
      onClick={updatePinState}
      isLoading={isLoading}
      hideLabel={hideButtonLabels}
    />
  );
};
